import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { DocumentsComponent } from './components/documents/documents.component';
import { DocumentosRoutingModule } from 'src/app/modules/documentos/documentos-routing.module';
import { MdbDatepickerModule  } from 'mdb-angular-ui-kit/datepicker';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';

import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { A11yModule } from '@angular/cdk/a11y';

import { MdbChipsModule } from 'mdb-angular-ui-kit/chips';
import { PdfViewerComponent } from 'src/app/components/pdf-viewer/pdf-viewer.component';
import { PoliticaSGIComponent } from './politica-sgi/politica-sgi.component';
import { ObjetivosSgiComponent } from './objetivos-sgi/objetivos-sgi.component';

import { MdbLightboxModule } from 'mdb-angular-ui-kit/lightbox'; 
import { MdbMultiItemCarouselModule } from 'mdb-angular-multi-item-carousel';
import { ContextoOrganizacionComponent } from './contexto-organizacion/contexto-organizacion.component';
import { AnalisisDeRiesgosYOportunidadesComponent } from './analisis-de-riesgos-y-oportunidades/analisis-de-riesgos-y-oportunidades.component';
import { MatrizDeRequisitosLegalesComponent } from './matriz-de-requisitos-legales/matriz-de-requisitos-legales.component';
import { ModeloDePrevencionDeDelitosComponent } from './modelo-de-prevencion-de-delitos/modelo-de-prevencion-de-delitos.component';

import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { MatrizSsomaComponent } from './matriz-ssoma/matriz-ssoma.component';

import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbLoadingModule } from 'mdb-angular-ui-kit/loading';

@NgModule({
  declarations: [
    DocumentsComponent, 
    PdfViewerComponent, 
    PoliticaSGIComponent, 
    ObjetivosSgiComponent, 
    ContextoOrganizacionComponent, 
    AnalisisDeRiesgosYOportunidadesComponent, MatrizDeRequisitosLegalesComponent, ModeloDePrevencionDeDelitosComponent, MatrizSsomaComponent],
  imports: [
    MdbLightboxModule,
    MdbMultiItemCarouselModule,
    CommonModule,
    DocumentosRoutingModule,
    MdbDatepickerModule,
    MdbFormsModule,
    MdbTableModule,
    A11yModule,
    MdbChipsModule,
    MdbTabsModule,
    MdbSelectModule,
    MdbLoadingModule
  ]
})
export class DocumentosModule { }